import API from '../../api/api'

const PARKING_STAFF_CREATE = 'PARKING_STAFF_CREATE'
const PARKING_STAFF_UPDATE = 'PARKING_STAFF_UPDATE'
const PARKING_STAFF_LOAD = 'PARKING_STAFF_LOAD'
const PARKING_STAFF_DELETE = 'PARKING_STAFF_DELETE'

const initialState = {
  parkingStaffUsers: [],
}

const parkingStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARKING_STAFF_LOAD: {
      return {
        ...state,
        parkingStaffUsers: action.parkingStaffUsers,
      }
    }
    case PARKING_STAFF_CREATE: {
      return {
        ...state,
        parkingStaffUsers: [action.data, ...state.parkingStaffUsers],
      }
    }
    case PARKING_STAFF_UPDATE: {
      return {
        ...state,
        parkingStaffUsers: state.parkingStaffUsers.map((parkingStaffUser) =>
          parkingStaffUser.id === action.data.id ? action.data : parkingStaffUser,
        ),
      }
    }
    case PARKING_STAFF_DELETE: {
      return {
        ...state,
        parkingStaffUsers: state.parkingStaffUsers.filter(
          (parkingStaffUser) => action.id !== parkingStaffUser.id,
        ),
      }
    }
    default:
      return state
  }
}

export const fetchParkingStaffUsers = (buildingId) => {
  return (dispatch) =>
    API.getAllParkingStaffUsers(buildingId)
      .then((res) => {
        dispatch(loadParkingStaffUsers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createParkingStaff = (data) => {
  console.log('data', data)

  return (dispatch) =>
    API.createNewManagementUser(data, 'parking-staff')
      .then((res) => {
        if (!res.errCode) dispatch({ type: PARKING_STAFF_CREATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateParkingStaff = (data, id) => {
  const parkingStaffUserBody = { firstName: data.firstName, lastName: data.lastName }
  return (dispatch) =>
    API.updateParkingStaffUser(parkingStaffUserBody, id)
      .then((res) => {
        if (!res.errCode) dispatch({ type: PARKING_STAFF_UPDATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const deleteParkingStaffUser = (id) => {
  return async (dispatch) => {
    try {
      await API.deleteParkingStaffUser(id)
      dispatch({ type: PARKING_STAFF_DELETE, id })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const loadParkingStaffUsers = (parkingStaffUsers) => {
  return {
    type: PARKING_STAFF_LOAD,
    parkingStaffUsers,
  }
}

export const selectParkingStaffUsers = (state) => state.parkingStaff.parkingStaffUsers

export default parkingStaffReducer
